import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import Note from '../elements/Note.jsx';
import BargraphResponse from './BargraphResponse';
import {useSelector, useDispatch} from 'react-redux';
import {selectedQuestionTotalResponses} from '../redux/QuestionsSlice';
import {toggleDisplaySideNav, toggleDisplayResults} from '../redux/mobileDisplays';
import {active} from '../redux/Filters';
import useMediaQuery from '../hooks/useMediaQuery';
import HorizontalResponse, {calculateRawPercent} from './HorizontalResponse';
import TranslationLabel from './TranslationLabel.jsx';
import FilterButtons from './Filters/FilterButton.jsx';
import {useSearchParams} from 'react-router-dom';

function Results(translations) {
  const noData = false;
  const isTablet = useMediaQuery('(max-width: 992px)');
  const question = useSelector(state => state.questions.selectedQuestion);
  const questionNumber = useSelector(state => state.questions.selectedQuestionNumber);
  const subquestions = useSelector(state => state.questions.selectedQuestionSubquestions);
  const questionDirection = useSelector(state => state.questions.selectedQuestionDirection);
  const questionResponse = useSelector(state => state.questions.selectedQuestionResponses);
  const totalQuestionResponses = useSelector(state => state.questions.totalQuestionResponses);
  const selectedNote = useSelector(state => state.questions.selectedNote);
  const responseDegree = translations.translations.Answer;
  const displayYear = useSelector(state => state.selectedYear.displayYear);

  
  const [params] = useSearchParams();
  const debug_prm = params.get('debug');

  const dispatch = useDispatch();
  const toggleMobileDisplays = () => {
    if (isTablet) {
      dispatch(toggleDisplayResults(false));
      dispatch(toggleDisplaySideNav(true));
      dispatch(active(false));
    }
  };
  const subKeys = useSelector(state => state.questions.selectedQuestionSubQKeys);


  let totalResponses = 0;
  let totalResponseSet;
  

  if(questionResponse){
    totalResponseSet = questionResponse.filter(res => Object.keys(res.response).length > 0);
  }

  if (!totalQuestionResponses && questionResponse) {
    dispatch(selectedQuestionTotalResponses(totalResponseSet));
  }

  let totalResponseNumber = [];
  if (questionResponse) {
    totalResponseSet?.forEach(res => totalResponseNumber.push(parseFloat(res.weight)));
    if (totalResponseNumber && totalResponseNumber.length > 0) {
      totalResponses = totalResponseNumber.reduce((prev, curr) => prev + curr);
    }
  }

  let filteredResponseDegree;

  if (subquestions) {
    filteredResponseDegree = responseDegree?.filter(
      r => r.trans_lang_variable_key === subquestions[0].v
    );
  }
  const filteredSingleResponseDegree = responseDegree?.filter(
    r => r.trans_lang_clean_qnum === questionNumber
  );

  const isVertical = questionDirection && questionDirection === 'MV';
  const isSingleQuestion = questionDirection && !subquestions;
  

    // console.log(filteredSingleResponseDegree);
    // console.log(isSingleQuestion)
    // console.log(subKeys[0])

  return (
    <section className="results">
      <Container className="no-border">
        {questionResponse ? <>
        <Row className="d-flex flex-column flex-lg-row mt-3">
          <Col md={12} lg={8}>
            <Row>
              <Col className="mb-0 mb-lg-2" lg={12}>
                <>
                  <div className="d-flex align-items-center">
                    <div
                      className="d-lg-none pr-2 fw-bold fs-1 pointer"
                      onClick={toggleMobileDisplays}
                    >
                      🠔
                    </div>
                    <h4 className="fw-light mb-0" onClick={toggleMobileDisplays}>
                      Q{questionNumber}:
                    </h4>
                  </div>
                </>
              </Col>
              <Col>
                <>
                  <div className="subquestions-type">{question}</div>{' '}
                </>
              </Col>
            </Row>
          </Col>
          <Col>
            <FilterButtons />
          </Col>
          
          {noData && (
            <p className="error-text">
              <strong>Data not available for: [country] [age group]</strong>
            </p>
          )}
          
          <div className="d-flex flex-column flex-lg-row justify-content-between light-gray mt-lg-2">
            <p className="pl-0 pb-0 text-left">
              {totalResponses && `${Math.round(totalResponses)}`}
              &nbsp;
              <TranslationLabel id="label_05" defaultValue="respondents" />
              {debug_prm && (
                <>
                  &nbsp;&nbsp;
                  <span>({totalResponses})</span>
                </>
              )}
            </p>
          </div>
        </Row>
       
        {filteredResponseDegree &&
          (isVertical ? (
            <>
              <Row>
                {filteredResponseDegree?.map((res, idx) => (
                  <Col className="text-center" key={idx}>
                    <h6>{res.trans_lang_variable_text}</h6>
                  </Col>
                ))}
              </Row>
              {filteredResponseDegree.length > 2 && (
                <div className="w-100 d-flex align-items-center">
                  <span>{'<'}</span>
                  <div className="d-inline-block dotted-arrow"></div>
                  <span>{'>'}</span>
                </div>
              )}
            </>
          ) : null)}

        {subquestions &&
          (isVertical
            ? subquestions?.map((sub, idx) => (
                <BargraphResponse
                  key={idx}
                  numOfCol={filteredResponseDegree.length}
                  subKeys={subKeys}
                  subquestionNumber={sub.v}
                  label={sub.vPay.vlang}
                  questionResponse={getReducedSet(questionResponse, sub.v)}
                />
              ))
            : [...subquestions]
                .sort((a, b) => {
                  const ap = calculateRawPercent(getReducedSet(questionResponse, a.v), a.v);
                  const bp = calculateRawPercent(getReducedSet(questionResponse, b.v), b.v);

                  return bp > ap ? 1 : -1;
                })
                ?.map((sub, idx) => (
                  <HorizontalResponse
                    key={idx}
                    subquestionNumber={sub.v}
                    label={sub.vPay.vlang}
                    questionResponse={getReducedSet(questionResponse, sub.v)}
                  />
                )))}
        {isSingleQuestion ? (
          <>
            <Row>
              {filteredSingleResponseDegree.map((res, idx) => {
                return (
                  <Col className="text-center" key={idx}>
                    <h6>{res.trans_lang_variable_text}</h6>
                  </Col>
                );
              })}
            </Row>
            <div className="w-100 d-flex align-items-center">
              <span>{'<'}</span>
              <div className="d-inline-block dotted-arrow"></div>
              <span>{'>'}</span>
            </div>
            <BargraphResponse
              numOfCol={filteredSingleResponseDegree.length}
              subKeys={subKeys}
              // questionResponse={getReducedSet(questionResponse, subKeys[0])}
              questionResponse={questionResponse}
            />
          </>
        ) : null}
        </> : <><h1 style={{textAlign: 'center'}}>{totalResponses && `${Math.round(totalResponses)}`}
              &nbsp; <TranslationLabel id="label_12" defaultValue="Data not available for: " /> {displayYear} </h1></>}
        
      </Container>
      {selectedNote && questionResponse && <Note />}
    </section>
  );
}

function getReducedSet(inputQuestionResponse, subquestionNumber) {
  if (inputQuestionResponse) {
    return inputQuestionResponse.filter(resp => {
      return resp.response[subquestionNumber] != null || undefined;
    });
  } else return [];
}

export default Results;